function createAddonId(descendantId, addonId, iteration) {
    return `1${createPart(descendantId)}${createPart(addonId)}${createPart(iteration)}`
}

function createPart(id) {
    const str = String(id);
    return Array.from(new Array(4 - str.length)).map((i) => '0').join('') + id;
}

export default createAddonId;